"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const LabeledInputFieldWidget_1 = tslib_1.__importDefault(require("../widget/LabeledInputFieldWidget"));
class WCAGIntervalField extends LabeledInputFieldWidget_1.default {
    constructor(args) {
        super({ ...args, inputType: "text" });
        this.validIntervalPattern = /^\d+([,.]\d+)?(-\d+([,.]\d+)?)?$/;
        this.validCharacterPattern = /[0-9,.-]/;
        const { allowDecimals = false, decimalsRequired = false, numberOfDecimals = 2 } = args;
        this.allowDecimals = allowDecimals;
        this.decimalsRequired = decimalsRequired;
        this.numberOfDecimals = numberOfDecimals;
    }
    isValidInputString(value) {
        return this.validIntervalPattern.test(value);
    }
    decorateLabeledInputFieldWidgetElement(args) {
        this.element = document.createElement("div");
        this.element.classList.add("interval-field");
        this.add(this.labelElement);
        this.add(this.fieldElement);
        this.add(this.hintElement);
    }
    setFieldElementValue(value) {
        // Update field value
        if (value === null || value === undefined) {
            this.fieldElement.value = "";
            return;
        }
        const { min, max } = value;
        if (this.allowDecimals) {
            this.fieldElement.value = (new fmko_ts_common_1.DecimalFormatter(this.numberOfDecimals, !this.decimalsRequired)).format(min);
            if (max !== undefined) {
                this.fieldElement.value += `-${(new fmko_ts_common_1.DecimalFormatter(this.numberOfDecimals, !this.decimalsRequired)).format(max)}`;
            }
            return;
        }
        this.fieldElement.value = WCAGIntervalField.integerFormat.format(min);
        if (max !== undefined) {
            this.fieldElement.value += `-${WCAGIntervalField.integerFormat.format(max)}`;
        }
    }
    parseFieldElementValue(inputValue) {
        if (!inputValue || inputValue.length === 0) {
            return undefined;
        }
        // Max value can be undefined
        const [minValue, maxValue] = inputValue.split("-");
        let min, max;
        if (this.allowDecimals) {
            min = parseFloat(minValue.replace(",", "."));
            max = parseFloat(maxValue?.replace(",", "."));
        }
        else {
            min = parseInt(minValue, 10);
            max = parseInt(maxValue, 10);
        }
        min = isNaN(min) ? undefined : min;
        max = isNaN(max) ? undefined : max;
        if (min === undefined) {
            return undefined;
        }
        return { min, max };
    }
    isValidNextChar(currentValue, char, selectionStart = null, selectionEnd = null) {
        if (!this.validCharacterPattern.test(char)) {
            return false;
        }
        if ((char >= "0" && char <= "9")) {
            return true;
        }
        if (char === "-") {
            if (!currentValue || currentValue.indexOf("-") === -1) {
                return true;
            }
        }
        if (this.allowDecimals && (char === ",")) {
            let numValue;
            if (currentValue) {
                const intervalSeparatorIndex = currentValue.indexOf("-");
                const pos = this.fieldElement.selectionStart;
                if (pos <= intervalSeparatorIndex) {
                    numValue = currentValue.substring(0, intervalSeparatorIndex);
                }
                else {
                    numValue = currentValue.substring(intervalSeparatorIndex + 1);
                }
            }
            else {
                numValue = currentValue;
            }
            if (!numValue || !(numValue.includes(","))) {
                return true;
            }
        }
        return false;
    }
}
WCAGIntervalField.integerFormat = new fmko_ts_common_1.IntegerFormatter();
exports.default = WCAGIntervalField;
//# sourceMappingURL=WCAGIntervalField.js.map